import {InjectionToken} from '@angular/core';

import {EnvInterface} from './env-interface';

export const ENV_TOKEN = new InjectionToken<EnvInterface>(
  'Application EnvInterface config token'
);

export const TRANSLATION_MESSAGE_CURRENT_ENVIRONMENT_TOKEN = new InjectionToken(
  'Application current environment translation json token'
);

export const TRANSLATION_MESSAGE_PRODUCTION_ENVIRONMENT_TOKEN =
  new InjectionToken(
    'Application production environment translation json token'
  );
